import { render, staticRenderFns } from "./Preco.vue?vue&type=template&id=c6f038ce&scoped=true"
import script from "./Preco.vue?vue&type=script&lang=js"
export * from "./Preco.vue?vue&type=script&lang=js"
import style0 from "./Preco.vue?vue&type=style&index=0&id=c6f038ce&prod&lang=css"
import style1 from "./Preco.vue?vue&type=style&index=1&id=c6f038ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f038ce",
  null
  
)

export default component.exports